/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 16:03:02                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-11-12 15:44:06                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * ActionItem: action component
*/

/* Imports */
import { ArrowUpRightIcon } from "@heroicons/react/24/solid";
import { Card, Typography } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
/***/

/**
* ActionItem: action component
* display other action
* redirect to dedicated page
*/
export default function ActionItem({
  data
}: {
  data: {
    name: string,
    icon: React.ReactNode,
    color: string,
    path: string
  }
}) {
  const navigate = useNavigate();

  return(
    <div className="action-item" onClick={() => navigate(data.path)}>
      <div className="flex justify-between">
        <Card className="icon" style={{backgroundColor: data.color}}>
          {data.icon}
        </Card>

        <ArrowUpRightIcon className="text-gray-300 w-6"/>
      </div>

      <Typography>
        {data.name}
      </Typography>
    </div>
  );
}
